export const format_number_to_real = (numero) => {
  if (numero === 0) {
    return 'R$0,00';
  }

  const currentNumero = numero.toFixed(2).split('.');
  currentNumero[0] = `R$ ${currentNumero[0].split(/(?=(?:...)*$)/).join('.')}`;
  return currentNumero.join(',');
};

export const format_real_to_number = (number) => {
  if (typeof number !== 'string') {
    return number;
  }

  if (number) {
    if (number.includes('R$')) {
      return parseFloat(
        number.replace('R$', '').replace(/./g, '').replace(/,/g, '.')
      );
    }
    return parseFloat(number.replace(/\./g, '').replace(/,/g, '.'));
  }
  return 0;
};
